// extracted by mini-css-extract-plugin
export default {"activateIndicator":"activateBeneficiaryModal_activateIndicator__4M+yw"};